import React from 'react';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from '@gamiphy/react-i18n';
import { ThemeStore } from '@gamiphy/loyalty-station-desktop/store/theme';
import { AppStore } from '@gamiphy/loyalty-station-desktop/store/app';
import CloseIcon from '@mui/icons-material/Close';
import { UiStore } from '@gamiphy/loyalty-station-desktop/store/ui';
import { useMobile } from '@gamiphy/loyalty-station-desktop/utils/mobile';

const Banner: React.FC<{ showClose?: boolean }> = ({ showClose = false }) => {
  const { t } = useTranslation();
  const isMobile = useMobile();
  const banner = ThemeStore.theme?.onboarding?.landing?.images?.length ? ThemeStore.theme?.onboarding?.landing?.images[0] : undefined;
  const brandColor = ThemeStore.theme?.palette?.primary?.main;
  const fontColor = ThemeStore.theme?.palette?.text?.secondary;
  const name = AppStore.app.name?.trim();

  return (
    <Grid container direction="column">
      <Grid
        sx={{
          width: '100%',
          backgroundImage: banner ? `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)),url('${banner}')` : undefined,
          backgroundColor: brandColor,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          height: '17.2rem',
          color: banner ? '#fff' : fontColor,
          position: 'relative',
        }}
      >
        <Grid
          container
          justifyContent={showClose ? 'space-between' : 'flex-start'}
          sx={{
            padding: (theme) => theme.spacing(2, 2, 1),
            display: 'flex',
            flexDirection: 'row',
            marginTop:
            // eslint-disable-next-line no-mixed-operators
              name && (name.length <= 15 || name.indexOf(' ') === -1) || isMobile
                ? (theme) => theme.spacing(4)
                : (theme) => theme.spacing(1),
          }}
        >
          <Grid container alignItems="center">
            <Typography sx={{ fontSize: '1.2rem' }} variant="h6" component="h6">
              {t('shared.welcomeTo', { defaultValue: 'Welcome to' })}
            </Typography>
            <Grid
              title={AppStore.app.name ?? undefined}
              sx={{
                fontSize: '2.4rem',
                fontWeight: 600,
                width: '100%',
                marginTop: (theme) => theme.spacing(1),
                textOverflow: 'ellipsis',
                overflow: 'hidden',
              }}
            >
              {AppStore.app.name}
            </Grid>
          </Grid>
          {showClose && (
            <Grid
              onClick={() => UiStore.close()}
              sx={{
                display: 'flex',
                backgroundColor: '#7c7c7c',
                borderRadius: 7,
                padding: (theme) => theme.spacing(1),
                position: 'absolute',
                top: '1rem',
                right: '1.5rem',
              }}
            >
              <CloseIcon sx={{ fontSize: '2.4rem', display: 'flex', color: '#fff' }} />
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Banner;
